import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FindPassword from "./FindPassword";
import {
  sendFindPasswordCodeAction,
  resetPasswordByCodeAction,
  findPasswordInit,
  resetPasswordInit
} from "../actionCreators";
import { REG_EX_PASSWORD } from "../../common/constants/commonConstant";

const FindPasswordContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [step, setStep] = useState("sendCode");
  const [mbrId, setMbrId] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);

  const {
    isSending,
    isCodeSent,
    sendError,
    isResetting,
    isReset,
    resetError
  } = useSelector(state => state.findPasswordReducer);

  // 코드 발송 성공 → 다음 단계
  useEffect(() => {
    if (isCodeSent) {
      dispatch(findPasswordInit());
      setStep("reset");
      setErrorMessage(null);
    }
  }, [isCodeSent, dispatch]);

  // 코드 발송 실패
  useEffect(() => {
    if (sendError) {
      setErrorMessage(sendError.retMsg || "인증코드 발송에 실패했습니다.");
      dispatch(findPasswordInit());
    }
  }, [sendError, dispatch]);

  // 비번 재설정 성공
  useEffect(() => {
    if (isReset) {
      alert("비밀번호가 변경되었습니다. 새 비밀번호로 로그인해주세요.");
      dispatch(resetPasswordInit());
      navigate("/");
    }
  }, [isReset, dispatch, navigate]);

  // 비번 재설정 실패
  useEffect(() => {
    if (resetError) {
      setErrorMessage(resetError.retMsg || "비밀번호 변경에 실패했습니다.");
      dispatch(resetPasswordInit());
    }
  }, [resetError, dispatch]);

  const onSendCode = useCallback(() => {
    setErrorMessage(null);
    if (!mbrId.trim()) {
      setErrorMessage("아이디를 입력해주세요.");
      return;
    }
    dispatch(sendFindPasswordCodeAction({ mbrId: mbrId.trim() }));
  }, [mbrId, dispatch]);

  const onResetPassword = useCallback(() => {
    setErrorMessage(null);

    if (!code.trim() || code.trim().length !== 6) {
      setErrorMessage("인증코드 6자리를 정확히 입력해주세요.");
      return;
    }

    if (newPassword !== newPasswordConfirm) {
      setErrorMessage("새 비밀번호가 일치하지 않습니다.");
      return;
    }

    if (!REG_EX_PASSWORD.test(newPassword)) {
      setErrorMessage(
        "비밀번호는 영문/숫자/특수문자를 포함한 8~15자여야 합니다."
      );
      return;
    }

    dispatch(
      resetPasswordByCodeAction({
        mbrId: mbrId.trim(),
        code: code.trim(),
        password: newPassword
      })
    );
  }, [mbrId, code, newPassword, newPasswordConfirm, dispatch]);

  const onClickCancel = useCallback(() => {
    navigate("/");
  }, [navigate]);

  return (
    <FindPassword
      step={step}
      mbrId={mbrId}
      code={code}
      newPassword={newPassword}
      newPasswordConfirm={newPasswordConfirm}
      onChangeMbrId={e => setMbrId(e.target.value)}
      onChangeCode={e => setCode(e.target.value)}
      onChangeNewPassword={e => setNewPassword(e.target.value)}
      onChangeNewPasswordConfirm={e => setNewPasswordConfirm(e.target.value)}
      onSendCode={onSendCode}
      onResetPassword={onResetPassword}
      onClickCancel={onClickCancel}
      isSending={isSending}
      isResetting={isResetting}
      errorMessage={errorMessage}
      successMessage={
        step === "reset" && !errorMessage
          ? `${mbrId}@dayside.co.kr 로 인증코드를 발송했습니다.`
          : null
      }
    />
  );
};

export default FindPasswordContainer;
